import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M7.961 5.333v5.33a.75.75 0 0 1-1.5 0v-5.33a.75.75 0 0 1 1.5 0Zm-2.45 2.52A2.274 2.274 0 0 1 6 9.313a1.932 1.932 0 0 1-2.11 2.1H2a.749.749 0 0 1-.75-.75v-5.33a.755.755 0 0 1 .75-.75h1.68a2 2 0 0 1 2.25 1.94 2.134 2.134 0 0 1-.419 1.33Zm-2.76-.77h1.04c.59 0 .64-.28.64-.56 0-.36-.41-.44-.75-.44h-.93ZM4.5 9.313a.641.641 0 0 0-.71-.73H2.751v1.33h1.14c.48 0 .609-.12.609-.6Zm9.67-4.71a.74.74 0 0 0-.84.39l-1.57 3.08-1.56-3.08a.751.751 0 0 0-1.42.34v5.33a.75.75 0 0 0 1.5 0v-2.2l.81 1.61a.786.786 0 0 0 1.34 0l.82-1.61v2.2a.75.75 0 0 0 1.5 0v-5.33a.749.749 0 0 0-.579-.733Z';
const draw24px =
  'M5.15,17.64H2a.75.75,0,0,1-.75-.75V8A.76.76,0,0,1,2,7.25H4.8c2,0,3.26,1.1,3.26,2.74a2.84,2.84,0,0,1-.89,2.2,3.21,3.21,0,0,1,1,2.45A2.73,2.73,0,0,1,5.15,17.64Zm-2.4-1.5h2.4c1.08,0,1.51-.43,1.51-1.5A1.55,1.55,0,0,0,5,12.92H2.75ZM5,11.42c1.57,0,1.57-1.08,1.57-1.43,0-1.12-1.23-1.24-1.76-1.24h-2v2.67Zm6.45,5.47V8a.75.75,0,1,0-1.5,0v8.89a.75.75,0,0,0,1.5,0Zm11.31,0V8a.75.75,0,0,0-1.42-.34l-3,6-3.05-6a.76.76,0,0,0-.85-.39.75.75,0,0,0-.57.73v8.89a.75.75,0,0,0,1.5,0V11.13l2.3,4.54a.79.79,0,0,0,1.34,0l2.3-4.54v5.76a.75.75,0,0,0,1.5,0Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const BimIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'bim'),
) as IconWithRender;

BimIcon.displayName = 'BimIcon';
BimIcon.propTypes = Icon.propTypes;
BimIcon.renderIcon = (props) => <BimIcon {...props} />;
export default BimIcon;
